import { scrollToTop } from 'common/utils';
import { Channels } from 'generated-graphql/types';
import { SHARED_SOURCING_AVAILABLE_CHANNELS } from 'modules/sourcing-shared/constants';
import { SourcingSharedSelectedCandidatesNextProps } from 'modules/sourcing-shared/shared-stores/types';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { generateStartingTemplatedMessageController } from '../generateStartingTemplatedMessageController';
import { hasSourcingSharedChannelSelectionEnabled } from '../hasSourcingSharedChannelSelectionEnabled';

type HandleSourcingSharedSelectedCandidatesNextControllerProps =
  SourcingSharedSelectedCandidatesNextProps & {
    get: SharedSourcingStoreApi['getState'];
    set: SharedSourcingStoreApi['setState'];
  };

export const handleSourcingSharedSelectedCandidatesNextController = async ({
  isChannelSelectionFeatureFlagEnabled,
  organizationChannelsEnabled,
  get,
  set
}: HandleSourcingSharedSelectedCandidatesNextControllerProps) => {
  scrollToTop();

  const hasChannelSelectionEnabled = hasSourcingSharedChannelSelectionEnabled({
    isChannelSelectionFeatureFlagEnabled,
    organizationChannelsEnabled
  });

  if (!hasChannelSelectionEnabled) {
    const { candidateBatch } = get();

    // Determine the default channel when skipping channel selection
    const availableChannels = SHARED_SOURCING_AVAILABLE_CHANNELS.filter(
      (channel) => organizationChannelsEnabled.includes(channel)
    );
    const defaultChannel =
      availableChannels.length > 0 ? availableChannels[0] : Channels.Email;

    // Set the channel form data and navigate to job information step
    set({
      step: 'JOB_INFORMATION',
      channelFormData: { channel: defaultChannel }
    });

    // Generate the starting templated message now that we have the channel
    if (candidateBatch) {
      await generateStartingTemplatedMessageController({
        get,
        set,
        jobDescription: candidateBatch.jobDescription,
        jobTitle: candidateBatch.jobDescriptionParsed?.jobTitle,
        employerName: candidateBatch.jobDescriptionParsed?.employerName,
        channel: defaultChannel
      });
    }

    return;
  }
  // Show channel selection step if there are multiple channels enabled
  set({ step: 'CHOOSE_CHANNEL' });
  return;
};
